import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const PlayblastSetkeyNsk = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M12.8484 1.8176C12.6234 1.5926 12.3117 1.4801 12 1.4801V12.0001H22.5328C22.5328 11.6931 22.4156 11.386 22.1812 11.1517L12.8484 1.8176Z"
        fill={color}
      />
      <path
        d="M1.8176 11.1516C1.5926 11.3766 1.4801 11.6883 1.4801 12H12.0001V1.46716C11.6931 1.46716 11.386 1.58436 11.1517 1.81876L1.8176 11.1516Z"
        fill={color}
      />
      <path
        d="M11.1516 22.1824C11.3766 22.4074 11.6883 22.5199 12 22.5199V11.9999H1.46722C1.46722 12.3069 1.58442 12.614 1.81882 12.8483L11.1516 22.1824Z"
        fill={color}
      />
      <path
        d="M22.1824 12.8484C22.4074 12.6234 22.5199 12.3117 22.5199 12H11.9999V22.5328C12.3069 22.5328 12.614 22.4156 12.8483 22.1812L22.1824 12.8484Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

PlayblastSetkeyNsk.displayName = 'PlayblastSetkeyNsk';
